{
  "pricing": {
    "loadingInfo": "Preisinformationen werden geladen...",
    "noPriceInfo": "Keine Preisinformationen verfügbar",
    "takeGoldmakingNextLevel": "Bringe dein Goldfarmen auf das nächste Level",
    "subscribeFrom": "Abonniere für nur {{price}} {{currency}} / Monat. Keine Bindung. Jederzeit kündbar.",
    "goldSubActive": "Dein aktuelles {{type}}-Abonnement läuft bis {{expiration}}",
    "goldSubTitle": "Gold-Abonnement aktiv",
    "goldSubUpgradeTitle": "Bereit für Premium?",
    "goldSubHeading": "Willkommen zurück, Goldmacher",
    "goldSubHeadingSubtitle": "Danke, dass du Gold-Mitglied bist — hier ist dein Abonnement auf einen Blick.",
    "upgradeToPremiumContact": "Um auf Premium upzugraden, wende dich bitte an unser Team im",
    "discordName": "Flipping Pal Discord",
    "manageBilling": "Abrechnung & Zahlungsmethoden verwalten",
    "manageBillingOpening": "Wird geöffnet...",
    "monthly": "Monatlich",
    "yearly": "Jährlich",
    "saveUpTo": "Spare bis zu {{percent}}% mit einem Jahresabonnement.",
    "mostPopular": "Am beliebtesten",
    "perMonth": "/Monat",
    "perYear": "/Jahr",
    "startDate": "Startdatum: {{date}}",
    "nextPaymentDate": "Nächstes Zahlungsdatum: {{date}}",
    "subscriptionEnds": "Abonnement endet: {{date}}",
    "reasonPaymentFailed": "Grund: Zahlung fehlgeschlagen",
    "reasonCancelled": "Grund: Gekündigt",
    "accessTools": "Auf die Tools zugreifen",
    "resumeSubscription": "Abonnement fortsetzen",
    "cancelSubscription": "Abonnement kündigen",
    "processing": "Wird verarbeitet...",
    "subscribeNow": "Jetzt abonnieren",
    "getStarted": "Loslegen",
    "switchToMonthly": "Zu monatlich wechseln",
    "switchToYearly": "Zu jährlich wechseln",
    "upgradeToPremium": "Auf Premium upgraden",
    "upgradeLabel": "Auf Premium upgraden ({{billing}})",
    "downgradeToBasic": "Auf Basic downgraden",
    "downgradeLabel": "Auf Basic downgraden ({{billing}})",
    "switchPlan": "Plan wechseln",
    "currentPlan": "Aktueller Plan",
    "statusActive": "Aktiv",
    "statusExpired": "Abgelaufen",
    "statusCanceled": "Gekündigt",
    "statusInCancelation": "In Kündigung",
    "showMoreFeatures": "+ {{count}} weitere Funktionen",
    "showFewerFeatures": "Weniger anzeigen"
  },
  "trial": {
    "activatedTitle": "Trial aktiviert!",
    "activatedSubtitle": "Das bekommst du – und das wartet noch auf dich",
    "startExploring": "Erkunden starten",
    "viewPlans": "Pläne anzeigen",
    "trialActive": "Kostenloser Trial aktiv",
    "daysRemaining": "{{count}} Tag verbleibend",
    "expires": "Läuft ab am {{date}}",
    "trialLabel": "Trial",
    "compareButton": "Tarife vergleichen",
    "trialEnded": "Dein kostenloser Trial ist abgelaufen. Abonniere oben, um FlippingPal weiter zu nutzen!",
    "haveTrialCode": "Hast du einen Trial-Code?",
    "trialCodeHint": "Nutze",
    "trialCodeHint2": "in unserem",
    "discordServer": "Discord-Server",
    "trialCodeHint3": "um einen zu erhalten",
    "activateButton": "Trial aktivieren",
    "activatingButton": "Wird aktiviert"
  },
  "features": {
    "basic": {
      "0": "Begrenzt auf 10 Verkaufs-Server",
      "1": "Housing Tool zum Flippen und Dropshippen von Housing-Dekor",
      "2": "Cross-Server Flipping Tool",
      "3": "Dropship Tool auf 3 Ergebnisse pro Gegenstand begrenzt",
      "4": "Server-Statistiken",
      "5": "TSM-Listengenerator",
      "6": "Bis zu 50 Gegenstand-Snipe-Benachrichtigungen für Discord",
      "7": "Filter-Voreinstellungen auf 3 begrenzt",
      "8": "Kundensupport durch das Team"
    },
    "premium": {
      "0": "Unbegrenzte Verkaufs-Server",
      "1": "Housing Tool zum Flippen und Dropshippen von Dekor",
      "2": "Cross-Server Flipping Tool",
      "3": "Dropship Tool auf 10 Ergebnisse pro Gegenstand erhöht",
      "4": "Server-Statistiken",
      "5": "TSM-Listengenerator",
      "6": "Inventaranalyse-Tool",
      "7": "Bis zu 9999 Gegenstand-Snipe-Benachrichtigungen für Discord",
      "8": "Filter-Voreinstellungen auf 50 begrenzt",
      "9": "Filter-Sharing mit Import-/Exportfunktion",
      "10": "Kundensupport durch das Team",
      "11": "Prioritäts-Support"
    }
  },
  "loading": "Abonnementinformationen werden geladen..."
}
